var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._g(_vm._b({attrs:{"dense":"","outlined":"","single-line":""}},'v-textarea',Object.assign({}, {rows: 6},
    _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }